import { ref } from 'vue';
import { isPromise } from '../functions';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useLoad = <T extends (...args: any[]) => any>(cb: T) => {
  const loading = ref(false);

  function load(...args: Parameters<T>): ReturnType<T> {
    loading.value = true;

    const result = cb(...args);

    if (isPromise(result)) {
      return result.then((value) => {
        loading.value = false;
        return value;
      }) as ReturnType<T>;
    }
    else {
      loading.value = false;
      return result;
    }
  }

  return { loading, load };
};
